module.exports = __webpack_public_path__ + "static/media/8.517fea4a.jpg";